import { VideoEmbedProps } from "../types/VideoEmbedTypes";
import { getEmbedUrl } from "../utils/getEmbedUrl";

export default function VideoEmbed(props: Readonly<VideoEmbedProps>) {
  const { videoUrl, title } = props;
  const embedUrl = getEmbedUrl(videoUrl);

  if (!embedUrl) {
    return null;
  }

  return (
    <iframe
      src={embedUrl}
      allowFullScreen
      title={title ?? ""}
      className="my-14 aspect-video w-full"
    />
  );
}
